import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    let mounted = true;
    api.users.me().then(u => {
      if (mounted) setUser(u);
    }).catch(() => {
      if (mounted) setUser(null);
    }).finally(() => {
      if (mounted) setInitializing(false);
    });
    return () => { mounted = false; };
  }, []);

  const login = async (credentials) => {
    const u = await api.users.login(credentials);
    setUser(u);
    return u;
  };

  const logout = async () => {
    await api.users.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, initializing, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
